export default __webpack_public_path__ + "static/media/Version (3) - Order of the Phoenix_18.30a3f82c.jpg";